import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { toast } from 'react-toastify'

import {
  getInfestationComparisonByFieldFromRegion,
  GetInfestationComparisonByFieldFromRegionResponse,
} from '@/services/get-infestation-comparison-by-field-from-region'

export type UseGetFieldInfestationFromDiagnosisResponse =
  GetInfestationComparisonByFieldFromRegionResponse

export const GET_INFESTATION_COMPARISON_BY_FIELD_FROM_REGION =
  'GET_INFESTATION_COMPARISON_BY_FIELD_FROM_REGION'

export function useGetInfestationComparisonByFieldFromRegion(
  regionId: number,
  fieldIds: string[],
  baseDemandId?: string,
  compareDemandId?: string,
) {
  const queryKey = useMemo(() => {
    return [
      GET_INFESTATION_COMPARISON_BY_FIELD_FROM_REGION,
      baseDemandId,
      compareDemandId,
      regionId,
      fieldIds,
    ]
  }, [baseDemandId, compareDemandId, regionId, fieldIds])

  const query = useQuery({
    queryKey,
    queryFn: () =>
      getInfestationComparisonByFieldFromRegion(
        baseDemandId!,
        compareDemandId!,
        String(regionId),
        fieldIds!,
      ),
    cacheTime: 0,
    enabled: !!baseDemandId && !!compareDemandId,
    onError(e: any) {
      const toastId = queryKey.join('-')

      if (toast.isActive(toastId)) return

      toast.error(
        `Ocorreu um erro ao fazer a comparação de infestação por talhão [${e.message}]`,
        { toastId },
      )
    },
  })

  return query
}
